import { BaseFrontdoorAdapter } from "../frontdoor/BaseFrontdoorAdapter";

export class FrontdoorLookupsAdapter extends BaseFrontdoorAdapter {
  constructor(options = {}) {
    super(options);
  }

  async getCountries() {
    const raw = await this.get("/api/countries");
    const countries = raw
      .map((item) => {
        return {
          id: item.id || item.countryId,
          countryId: item.countryId || item.id,
          countryGUID: item.countryId,
          countryName: item.countryName,
          isocode: item.isoCode,
          isActive: item.isActive,
          createdOn: item.createdOn,
        };
      })
      .sort((a, b) => a.id - b.id);
    return {
      countries,
    };
  }

  async getStatesProvinces() {
    const raw = await this.get("/api/state-provinces");
    const statesProvinces = raw.map((item) => {
      return {
        id: item.id ?? item.stateProvinceId,
        stateProvinceId: item.stateProvinceId ?? item.id,
        countryId: item.countryId,
        stateProvinceName: item.stateProvinceName,
        code: item.code,
        type: item.type,
        isActive: item.isActive,
        createdOn: item.createdOn,
      };
    });
    return {
      statesProvinces,
    };
  }

  async getLanguages() {
    const raw = await this.get("/api/languages");
    return {
      languages: raw.map((item) => ({
        id: item.id || item.languageId,
        name: item.name || item.languageName,
      })),
    };
  }

  async getIndustries() {
    const raw = await this.get("/api/industries");
    return {
      industries: raw.map((item) => ({
        id: item.id,
        name: item.name,
      })),
    };
  }

  async getBusinessCategories() {
    const raw = await this.get("/api/business-categories");
    return {
      businessCategory: {
        items: raw.map((item) => ({
          id: item.id,
          name: item.name,
        })),
      },
    };
  }

  async getTimezones() {
    const raw = await this.get("/api/timezones");
    return {
      timeZones: raw.map((item) => ({
        key: item.key,
        value: item.value,
      })),
    };
  }

  async getSystemUsers() {
    const raw = await this.get("/api/system-users");
    return {
      systemUsers: {
        items: raw.map((item) => ({
          id: item.id,
          displayName: item.displayName,
          userName: item.userName,
          ssoEmail: item.ssoEmail,
          phone: item.phone,
          isDeleted: item.isDeleted,
        })),
      },
    };
  }

  async getUserCompanies(userEmail) {
    const raw = await this.get("/api/UserCompanies");
    return {
      userCompanies: raw.map((item) => ({
        id: item.id,
        name: item.companyName,
        companyKey: item.companyKey,
        roleName: item.roleName,
      })),
    };
  }
}
